var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGtouch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 202,
    height: 202,
    viewBox: "0 0 202 202",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_135382",
    "data-name": "Group 135382",
    transform: "translate(-131 -651)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15500",
    "data-name": "Ellipse 15500",
    cx: 101,
    cy: 101,
    r: 101,
    transform: "translate(131 651)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "get-in-touch",
    transform: "translate(176 696)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Communicate"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12553",
    "data-name": "Rectangle 12553",
    width: 65,
    height: 70,
    rx: 2,
    transform: "translate(89 8)",
    fill: "#ffcdcb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12554",
    "data-name": "Rectangle 12554",
    width: 65,
    height: 70,
    rx: 2,
    transform: "translate(8 8)",
    fill: "#ffcdcb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505664",
    "data-name": "Path 505664",
    d: "M0,0H7.6V17.726H0Z",
    transform: "translate(20.943 21.126) rotate(-45)",
    fill: "#ff7956"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505665",
    "data-name": "Path 505665",
    fill: "#57a4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505666",
    "data-name": "Path 505666",
    d: "M20.807,20.878,8.272,8.343Z",
    transform: "translate(12.675 12.784)",
    fill: "#57a4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505667",
    "data-name": "Path 505667",
    d: "M31.656,31.727,19.121,19.192Z",
    transform: "translate(29.298 29.407)",
    fill: "#57a4ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12555",
    "data-name": "Rectangle 12555",
    width: 65,
    height: 65,
    rx: 2,
    transform: "translate(8 89)",
    fill: "#ffcdcb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505668",
    "data-name": "Path 505668",
    d: "M24.138,57.219l.03-.025-.03.025,3.958,3.52a2.532,2.532,0,0,0,3.388,0l3.958-3.515-.03-.03.03.025L52.581,42H7Z",
    transform: "translate(10.726 64.355)",
    fill: "#ffb655"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505669",
    "data-name": "Path 505669",
    d: "M7,42V72.387L24.138,57.219Z",
    transform: "translate(10.726 64.355)",
    fill: "#ff9811"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505670",
    "data-name": "Path 505670",
    d: "M5,67.774H60.71a5.065,5.065,0,0,0,5.065-5.065V7A60.774,60.774,0,0,1,5,67.774Z",
    transform: "translate(7.661 10.726)",
    fill: "#c91006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505671",
    "data-name": "Path 505671",
    d: "M0,0H7.6V17.726H0Z",
    transform: "translate(48.411 48.603) rotate(-45)",
    fill: "#ff7956"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505672",
    "data-name": "Path 505672",
    d: "M25.01,35.815,24.4,35.2a10.129,10.129,0,0,1,0-14.325L11.863,8.343a20.258,20.258,0,0,0,0,28.65L23.22,48.35a20.258,20.258,0,0,0,28.65,0L39.335,35.815a10.129,10.129,0,0,1-14.325,0Z",
    transform: "translate(9.084 12.784)",
    fill: "#ffcd00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505673",
    "data-name": "Path 505673",
    d: "M5,97.774H60.71a5.065,5.065,0,0,0,5.065-5.065V37A60.774,60.774,0,0,1,5,97.774Z",
    transform: "translate(7.661 56.694)",
    fill: "#c91006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505674",
    "data-name": "Path 505674",
    d: "M35.37,72.387V42L18.232,57.219Z",
    transform: "translate(27.936 64.355)",
    fill: "#ff9811"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505675",
    "data-name": "Path 505675",
    d: "M31.484,51.53a2.532,2.532,0,0,1-3.388,0l-3.958-3.52L7,63.178H52.581L35.442,48.01Z",
    transform: "translate(10.726 73.564)",
    fill: "#ffa733"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505676",
    "data-name": "Path 505676",
    d: "M37,67.774H92.71a5.065,5.065,0,0,0,5.065-5.065V7A60.774,60.774,0,0,1,37,67.774Z",
    transform: "translate(56.694 10.726)",
    fill: "#c91006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505677",
    "data-name": "Path 505677",
    d: "M62.7,28.495a4.971,4.971,0,0,0-4.019-1.474,5.254,5.254,0,0,0-4.616,5.328V82.711L46.188,66.023a5.065,5.065,0,0,0-6.2-3.6l-2.33.628A2.532,2.532,0,0,0,35.9,66.269l10.567,30.7,7.44,8.787.157,7.344H89.515v-7.6l5.065-7.6V64.985a5.065,5.065,0,1,0-10.129,0V59.92a5.065,5.065,0,0,0-10.129,0V54.856a5.065,5.065,0,0,0-10.129,0V32.065a4.951,4.951,0,0,0-1.494-3.57Z",
    transform: "translate(54.824 41.37)",
    fill: "#ffbcab"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_135381",
    "data-name": "Group 135381",
    transform: "translate(5.065 5.065)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505678",
    "data-name": "Path 505678",
    d: "M60.559,45.971,48.027,33.436a2.532,2.532,0,0,0-3.581,0l-5.373,5.371a7.6,7.6,0,0,1-10.744,0l-.613-.613a7.6,7.6,0,0,1,0-10.744l5.371-5.373a2.532,2.532,0,0,0,0-3.581L20.549,5.964a2.532,2.532,0,0,0-3.581,0L11.6,11.335a22.816,22.816,0,0,0,0,32.231L22.955,54.922a22.816,22.816,0,0,0,32.231,0l5.373-5.371A2.532,2.532,0,0,0,60.559,45.971ZM46.237,38.807l8.952,8.954-1.79,1.79L44.446,40.6ZM18.762,11.335l8.952,8.952-1.79,1.793-8.954-8.954Zm7.774,40.01L15.178,39.985a17.756,17.756,0,0,1-1.664-23.15l9,9a12.684,12.684,0,0,0,1.613,15.935l.613.613A12.692,12.692,0,0,0,40.681,44l9,9a17.759,17.759,0,0,1-23.15-1.664Z",
    transform: "translate(2.494 2.937)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505679",
    "data-name": "Path 505679",
    d: "M65.306,77.968H9.6a7.6,7.6,0,0,1-7.6-7.6V9.6A7.6,7.6,0,0,1,9.6,2h55.71a7.6,7.6,0,0,1,7.6,7.6V70.371A7.6,7.6,0,0,1,65.306,77.968ZM9.6,7.065A2.532,2.532,0,0,0,7.065,9.6V70.371A2.532,2.532,0,0,0,9.6,72.9h55.71a2.532,2.532,0,0,0,2.532-2.532V9.6a2.532,2.532,0,0,0-2.532-2.532Z",
    transform: "translate(-2 -2)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505680",
    "data-name": "Path 505680",
    d: "M65.306,104.9H9.6a7.6,7.6,0,0,1-7.6-7.6V41.6A7.6,7.6,0,0,1,9.6,34h55.71a7.6,7.6,0,0,1,7.6,7.6v55.71a7.6,7.6,0,0,1-7.6,7.6ZM9.6,39.065A2.532,2.532,0,0,0,7.065,41.6v55.71A2.532,2.532,0,0,0,9.6,99.839h55.71a2.532,2.532,0,0,0,2.532-2.532V41.6a2.532,2.532,0,0,0-2.532-2.532Z",
    transform: "translate(-2 47.032)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505681",
    "data-name": "Path 505681",
    d: "M54.113,41H8.532A2.532,2.532,0,0,0,6,43.532V73.919a2.532,2.532,0,0,0,2.532,2.532H54.113a2.532,2.532,0,0,0,2.532-2.532V43.532A2.532,2.532,0,0,0,54.113,41ZM31.323,60.372,15.2,46.065H47.443Zm-9.455-1.623L11.065,68.3V49.167Zm3.814,3.386L27.96,64.16a5.047,5.047,0,0,0,6.764.013L37,62.147l10.428,9.24H15.215ZM40.8,58.749l10.777-9.582V68.3Z",
    transform: "translate(4.129 57.758)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505682",
    "data-name": "Path 505682",
    d: "M97.306,2H41.6A7.6,7.6,0,0,0,34,9.6V70.371a7.6,7.6,0,0,0,7.6,7.6H54.258v31.749L51.3,103.44a7.5,7.5,0,0,0-3.467-4.383,7.614,7.614,0,0,0-5.776-.76l-2.332.628a5.065,5.065,0,0,0-3.489,6.483l10.57,30.7a2.5,2.5,0,0,0,.461.81l6.86,8.1.137,6.434a2.532,2.532,0,0,0,2.532,2.479H92.242a2.532,2.532,0,0,0,2.532-2.532v-6.837l4.639-6.959a2.548,2.548,0,0,0,.425-1.4V103.29a7.409,7.409,0,0,0-2.213-5.338,7.744,7.744,0,0,0-8.179-1.727,7.26,7.26,0,0,0-1.95-3.337,7.749,7.749,0,0,0-8.179-1.727,7.26,7.26,0,0,0-1.95-3.338A7.731,7.731,0,0,0,69.452,86v-8.03H97.306a7.6,7.6,0,0,0,7.6-7.6V9.6a7.6,7.6,0,0,0-7.6-7.6ZM71.984,90.629a2.466,2.466,0,0,1,1.8.775,2.423,2.423,0,0,1,.729,1.757v17.726a2.532,2.532,0,1,0,5.065,0V98.226a2.532,2.532,0,0,1,2.532-2.532,2.466,2.466,0,0,1,1.8.775,2.423,2.423,0,0,1,.729,1.757v12.661a2.532,2.532,0,1,0,5.065,0v-7.6a2.532,2.532,0,0,1,2.532-2.532,2.466,2.466,0,0,1,1.8.775,2.423,2.423,0,0,1,.729,1.757v32.16l-4.639,6.959a2.547,2.547,0,0,0-.425,1.4v5.065H59.269l-.1-4.864a2.532,2.532,0,0,0-.6-1.585L51.432,134,41.037,103.8l2.314-.623a2.578,2.578,0,0,1,1.945.253,2.482,2.482,0,0,1,1.17,1.519c.038.149,8.035,17.126,8.035,17.126a2.532,2.532,0,0,0,4.821-1.056V70.655a2.74,2.74,0,0,1,2.3-2.816,2.466,2.466,0,0,1,2.038.76,2.423,2.423,0,0,1,.729,1.773v40.516a2.532,2.532,0,1,0,5.065,0V93.161a2.532,2.532,0,0,1,2.532-2.532ZM99.839,70.371A2.532,2.532,0,0,1,97.306,72.9H69.452V70.371a7.409,7.409,0,0,0-2.213-5.338A7.511,7.511,0,0,0,61.194,62.8a7.792,7.792,0,0,0-6.936,7.853V72.9H41.6a2.532,2.532,0,0,1-2.532-2.532V9.6A2.532,2.532,0,0,1,41.6,7.065h55.71A2.532,2.532,0,0,1,99.839,9.6Z",
    transform: "translate(47.032 -2)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505683",
    "data-name": "Path 505683",
    d: "M60.258,8a20.258,20.258,0,0,0,0,40.516H70.387a2.532,2.532,0,0,0,0-5.065H60.258A15.194,15.194,0,1,1,75.452,28.258V30.79a2.532,2.532,0,0,1-5.065,0V28.258a10.213,10.213,0,1,0-3.256,7.394A7.564,7.564,0,0,0,80.516,30.79V28.258A20.281,20.281,0,0,0,60.258,8Zm0,25.323a5.065,5.065,0,1,1,5.065-5.065A5.065,5.065,0,0,1,60.258,33.323Z",
    transform: "translate(56.226 7.194)",
    fill: "#231f20"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGtouch);
export default __webpack_public_path__ + "static/media/Gtouch.87eed319a5c788da93ecf671571298b9.svg";
export { ForwardRef as ReactComponent };